jQuery( function ($) {

  if ( typeof gform != 'object' ) { return }

  $(document).on( 'gform_post_render', function ( e, form_id, current_page ) {
    observe_size( form_id )
  })

  const ro = new ResizeObserver( entries => {
    for ( let entry of entries ) {
      set_inline_submit_styles( $( entry.target ) )
    }
  })

  function observe_size ( form_id ) {
    $( `form#gform_${ form_id } .gform_fields` ).each( function () {
      if ( $( '.gfield--width-fill + .gfield--type-submit', this ).length ) {
        ro.observe( this )
      }
    })
  }

  function set_inline_submit_styles ( $gfields ) {
    const $submit = $( '.gfield--width-fill + .gfield--type-submit', $gfields )
    if ( $submit.length ) {
      const $filled = $submit.prev()
      $filled.addClass( 'btn-inline' )
      $filled.toggleClass( 'btn-inline', ( $submit.get(0).offsetTop == $filled.get(0).offsetTop ) )
    }
  }

})